// src/App.tsx
import React from 'react';
import { AppRoutes } from './Routes/AppRoutes';

function App() {
  return (
   
   <>
   < AppRoutes />
   </>
  );
}

export default App;